import PureTable from '../../../common/PureTable/PureTable';
import { AdaptedApiUser } from './CourseIndividuals.types';
import { ItemDeleteState } from '../../../../lib/hooks/useDeleteState';
import CardBadge from '../CourseCard/CardBadge';
import { getTrainingStatusKey } from '../TableManager/TableManager.utils';
import styles from './CourseIndividuals.module.scss';
import { Api } from '../../../../lib/types/apiSpec';

export const adaptUserProps =
  (userDeleteState: ItemDeleteState) =>
  (deleteHandler: (id: string) => void) =>
  ({ id = '', status, ...rest }: Api.TrainingUsers): AdaptedApiUser => {
    return {
      ...rest,
      id,
      fullName: `${rest.firstName} ${rest.lastName}`,
      status: (
        <CardBadge
          className={styles.statusBadge}
          key={getTrainingStatusKey(status)}
          status={status}
          withNotStartedBadge
        />
      ),
      removeUser: !userDeleteState[id] ? (
        <PureTable.DeleteAction key={`delete-${id}`} id={id} titleKey="delete.individual" onClick={deleteHandler} />
      ) : (
        <PureTable.Loader key={`delete-loader-${id}`} />
      ),
    };
  };
